import styles from './CheckoutReviewPage.scss';

import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CheckoutRoutePath } from 'src/components/Checkout/Checkout';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { redesignV2RoutePath } from 'src/constants/redesignV2';
import { useCheckout } from '../CheckoutProvider';
import { ReviewOrderList } from './ReviewOrderList';

export const CheckoutReviewPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { continueButtonRef } = useCheckout();
  const reviewDiv = useRef<HTMLDivElement>(null);

  const onContinue = () => {
    const emailPage = `${redesignV2RoutePath.PURCHASE}${CheckoutRoutePath.EMAIL}`;
    history.push(emailPage);
  };

  useEffect(() => {
    if (reviewDiv?.current) {
      reviewDiv.current.focus();
    }
  }, [reviewDiv]);

  return (
    <div className={styles.checkoutReview} ref={reviewDiv} tabIndex={-1}>
      <TextV2
        tagName="h2"
        variant="h2-bold"
        className={styles.heading}
        value={t('checkout-review.review-title')}
      />
      <ReviewOrderList />
      <button ref={continueButtonRef} className={styles.checkoutReviewBtn} onClick={onContinue}>{t('continue')}</button>
    </div>
  );
};
